export default __webpack_public_path__ + "static/media/CardDbQuize.f9888484.svg";